
        export class GlobalVenteStat {

            msisdn:any;
            
            nafama_total_zone:any;
            nafama_total_hors_zone:any;
            nafama_total:any;
            nafama_taux:any;

            wallet_total_zone:any;
            wallet_total_hors_zone:any;
            wallet_total:any;
            wallet_taux:any;

            carte_total_zone:any;
            carte_total_hors_zone:any;
            carte_total:any;
            carte_taux:any;

            total_zone:any;
            total_hors_zone:any;
            total:any;
            taux:any;

            total_part_vente:any;
            nafama_part_vente:any;
            carte_part_vente:any;
            wallet_part_vente:any;

            constructor() { }
        }
        